(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["splash-screen"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
		const splashScreen = document.getElementById('splashEl');
		if (!splashScreen) return;

		if (splashScreen.classList.contains('splash-screen-hidden')) {
			return;
		}

		const closeButton = document.getElementById('close-splash');
		const isInfinityPage = window.location.pathname.includes('/pages/infinity');

		const lastSeen = localStorage.getItem('splashLastSeen');
		const fiveDaysInMs = 5 * 24 * 60 * 60 * 1000;
		let shouldHide = false;

		if (lastSeen && Date.now() - parseInt(lastSeen, 10) < fiveDaysInMs) {
			shouldHide = true;
		}

		// Check SessionStorage
		if (!isInfinityPage && shouldHide) {
			splashScreen.classList.add('splash-screen-hidden');
			return;
		}

		// Lock Scrolling
		document.body.classList.add('no-smooth');

		let incr = 400;
		let deltaObject = { delta: 0 };
		let deltaTo;
		let tl; // gsap timeline
		let mm = gsap.matchMedia(); // Initialize gsap matchMedia
		let isWheeling; // listen to desktop scroll
		let touchLastY = 0; // listen to mobile scroll
		let indexImg = 0;

		const mediaArray = [];
		const ANIMATION_SPEED = 1.25;

		const root = document.querySelector('.media-wrapper');
		const mediaList = root.querySelector('.media-list');

		// Extract image URLs from the hidden preload elements
		root.querySelectorAll('.preload-medias img').forEach((image) => {
			mediaArray.push(image.getAttribute('src'));
		});

		const medias = root.querySelectorAll('.media');
		const mediasImg = root.querySelectorAll('.media img');

		deltaTo = gsap.quickTo(deltaObject, 'delta', { duration: 2, ease: 'power1' });
		const rotY = gsap.quickTo(mediaList, 'rotationY', { duration: 0.5, ease: 'power1' });
		const rotX = gsap.quickTo(mediaList, 'rotationX', { duration: 0.5, ease: 'power1' });

		mm.add(
			{
				isDesktop: '(min-width: 600px)',
				isMobile: '(max-width: 599px)',
			},
			(context) => {
				let { isMobile, isDesktop } = context.conditions;

				gsap.set(medias, {
					width: isMobile ? '60%' : '33%',
				});

				const minSpread = isMobile ? 0.2 : 0.1;
				const maxSpread = isMobile ? 0.8 : 0.9;

				function updateMedia(media) {
					gsap.set(media, {
						xPercent: -50,
						yPercent: -50,
						x: (Math.random() * (maxSpread - minSpread) + minSpread) * window.innerWidth,
						y: (Math.random() * (maxSpread - minSpread) + minSpread) * window.innerHeight,
					});

					// Random image selector
					// const randomIndex = Math.floor(Math.random() * mediaArray.length);

					indexImg = (indexImg + 1) % mediaArray.length;
					media.querySelector('img').setAttribute('src', mediaArray[indexImg]);
				}

				medias.forEach((media) => {
					updateMedia(media);
				});

				tl = gsap.timeline({ paused: true });

				tl.to(medias, {
					z: isMobile ? window.innerWidth * 1.5 : window.innerWidth,
					ease: 'none',
					duration: 8, // IMPORTANT: Needs to me the same amount as the total media list items
					stagger: {
						each: 1,
						repeat: -1,
						onRepeat() {
							updateMedia(this.targets()[0]);
						},
					},
				});

				// Scale in animation
				tl.fromTo(
					mediasImg,
					{ scale: 0 },
					{
						scale: 1,
						ease: 'power2.out',
						duration: 0.6,
						stagger: {
							each: 1,
							repeat: -1,
							repeatDelay: 7.4,
							onRepeat() {
								this.targets()[0].style.transform = 'scale(0, 0)';
							},
						},
					},
					'<',
				);

				// Scale out animation
				tl.fromTo(
					mediasImg,
					{ scale: 1 },
					{
						scale: 0,
						ease: 'expo.in',
						duration: 0.6,
						immediateRender: false,
						delay: 7.4,
						stagger: {
							each: 1,
							repeat: -1,
							repeatDelay: 7.4,
							onRepeat() {
								this.targets()[0].style.transform = 'scale(1, 1)';
							},
						},
					},
					'<',
				);
			},
		);

		function tick(time, dt) {
			incr += deltaObject.delta / 500 + (dt / 1000) * ANIMATION_SPEED;
			if (tl) tl.time(incr);
		}

		function handleWheel(e) {
			deltaTo(e.deltaY);
			window.clearTimeout(isWheeling);
			isWheeling = setTimeout(() => {
				deltaTo(0);
			}, 120);
		}

		// Start Ticker and Listeners
		gsap.ticker.add(tick);
		window.addEventListener('wheel', handleWheel, { passive: true });
		window.addEventListener(
			'touchstart',
			(e) => {
				touchLastY = e.touches[0].clientY;
			},
			{ passive: true },
		);
		window.addEventListener(
			'touchmove',
			(e) => {
				const currentY = e.touches[0].clientY;
				const touchDeltaY = touchLastY - currentY;

				deltaTo(touchDeltaY * 5); // adjust speed as needed
				touchLastY = currentY;
				window.clearTimeout(isWheeling);
				isWheeling = setTimeout(() => {
					deltaTo(0);
				}, 120);
			},
			{ passive: true },
		);

		root.addEventListener('mousemove', (e) => {
			const valY = (e.clientX / window.innerWidth - 0.5) * 20;
			const valX = (e.clientY / window.innerHeight - 0.5) * 20;
			rotY(valY);
			rotX(-valX);
		});

		// Close splashscreen
		const enterStore = () => {
			if (isInfinityPage) {
				localStorage.setItem('splashLastSeen', Date.now());
				window.location.href = '/';
			} else {
				gsap.to(splashScreen, {
					opacity: 0,
					duration: 0.6,
					ease: 'power2.inOut',
					onComplete: () => {
						localStorage.setItem('splashLastSeen', Date.now());
						splashScreen.classList.add('splash-screen-hidden');
						document.documentElement.classList.remove('has-splashscreen');
						document.body.classList.remove('has-splashscreen');
						gsap.ticker.remove(tick);
					},
				});
			}
		};

		closeButton.addEventListener('click', enterStore);
	});
  } catch(e) { console.error(e); }
})();

})();
